"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentBoundarySchema = void 0;
const zod_1 = require("zod");
const IBoundaryDefinition_1 = require("./DesignModels/IBoundaryDefinition");
const IModeCondition_1 = require("./DesignModels/IModeCondition");
exports.ComponentBoundarySchema = zod_1.z.object({
    id: zod_1.z.string(),
    global: zod_1.z.boolean().optional(),
    conditions: IModeCondition_1.IModeConditionSchema.array().optional(),
    boundary: IBoundaryDefinition_1.IBoundaryDefinitionSchema,
});
//# sourceMappingURL=ComponentBoundary.js.map